<template>
  <v-card class="my-2" v-if="billing" >
    <v-card-title class="title" :class="!forSupplier ? 'card-title-head' : 'supplier-title-head'" @click="expand = !expand">
      <v-icon v-if="!expand">mdi-chevron-right</v-icon>
      <v-icon v-if="expand">mdi-chevron-down</v-icon>
      {{ forSupplier ? "" : $i18n.t("Client Charges") }}
      <v-row class="float-left">
        <v-col cols="12" md="4" sm="4" lg="4" v-if="forSupplier">
          <z-vendor-select
            v-model="billing.vendor_id"
            :label="$i18n.t('Supplier')"
          />
        </v-col>
        <v-col cols="12" md="4" sm="4" lg="4" v-if="forSupplier">
          <v-btn color="blue lighten-1" small @click="printSupplierSummary">
            {{ $i18n.t("Print Summary") }}
          </v-btn>
        </v-col>
      </v-row>
      <v-spacer />
      <v-row class="float-right">
        <v-col cols="12" md="12" sm="12" lg="12" class="text-right">
          <v-btn
            color="error"
            small
            fab
            text
            @click="removeBill"
            v-if="forSupplier"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <div v-if="!expand && trip._id">
        <strong>{{ $i18n.t("Total") }}:</strong>
        {{ fare.total }}
        <strong>{{ $i18n.t("Pending") }}:</strong>
        {{ fare.pending }}
      </div>
    </v-card-title>
    <v-expand-transition>
      <v-card-text class="py-0" dense v-if="expand">
        <v-row dense>
          <v-col cols="12" md="12" class="text-right">
            <!-- <v-card-title class="subtitle-1">{{
            $i18n.t("Charges")
          }}</v-card-title> -->
            <v-spacer />
            <v-btn
              v-if="fare && (!fare.charges || fare.charges.length == 0)"
              @click="fare.charges = newChargeItem(fare.charges)"
              x-small
              fab
              color="blue"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12" md="12">
            <v-simple-table v-if="fare" dense>
              <thead v-if="fare.charges.length">
                <tr style="background-color: rgb(245 248 248)">
                  <th width="60%">{{ $i18n.t("Charges") }}</th>
                  <!-- <th width="10%">{{ $i18n.t("Name") }}</th>
                <th width="15%">{{ $i18n.t("Description") }}</th>
                <th width="5%">{{ $i18n.t("Unit(s)") }}</th>
                <th width="10%">{{ $i18n.t("Rate") }}</th> -->
                  <!-- <th width="10%">{{ $i18n.t("Discount Desc") }}</th> -->
                  <th width="30%">
                    {{ $i18n.t("Deductions/Penalty/Discount") }}
                  </th>
                  <th width="7%">{{ $i18n.t("Tax") }}</th>
                  <!-- <th width="15%">{{ $i18n.t("Amount") }}</th> -->
                  <th>{{ $i18n.t("Action") }}</th>
                </tr>
              </thead>
              <!-- <z-charge-type
                    v-model="charge.name"
                    klass="ma-0 pa-0"
                    :disabled="
                      billing.fareTariff &&
                      billing.fareTariff._id &&
                      billing.fareTariff._id.length > 20
                    "
                  /> -->
              <tbody>
                <tr
                  v-for="(charge, i) in fare.charges"
                  :key="i + 'charge_billing_fare'"
                  style="outline: 1px auto #e8e8e8"
                >
                  <td width="60%" style="padding-left: 0px">
                    <v-simple-table v-if="charge" dense>
                      <thead>
                        <tr style="background-color: rgb(235 244 246)">
                          <th>{{ $i18n.t("Name") }}</th>
                          <!-- <th>{{ $i18n.t("Description") }}</th> -->
                          <th>{{ $i18n.t("Unit(s)") }}</th>
                          <th>{{ $i18n.t("Rate") }}</th>
                          <th>{{ $i18n.t("Amount") }}</th>
                          <th>
                            <v-btn
                              v-if="
                                charge &&
                                  (!charge.items || charge.items.length == 0)
                              "
                              @click="charge.items = newItem(charge.items)"
                              text
                              x-small
                              fab
                              color="blue"
                            >
                              <v-icon>mdi-plus</v-icon>
                            </v-btn>
                          </th>
                        </tr>
                      </thead>
                      <tbody v-if="charge.items && charge.items.length">
                        <tr v-for="(item, i) in charge.items" :key="i">
                          <td>
                            <z-name-master-select
                              v-model="item.name"
                              :dense="true"
                              :type="8"
                              label
                              :hideAddNew="true"
                              :addNewLabel="'Add Fare Item'"
                              :disabled="
                                (billing.fareTariff &&
                                  billing.fareTariff._id &&
                                  billing.fareTariff._id.length > 20) ||
                                  trip.disableFareEdit
                              "
                            />
                          </td>
                          <!-- <td>
                          <v-text-field
                            v-model="item.desc"
                            class="ma-0 pa-0"
                            :disabled="
                              billing.fareTariff &&
                              billing.fareTariff._id &&
                              billing.fareTariff._id.length > 20
                            "
                          />
                        </td> -->
                          <td>
                            <v-text-field
                              v-model="item.units"
                              type="number"
                              class="ma-0 pa-0"
                              @blur="calculateFare"
                              :disabled="
                                (billing.fareTariff &&
                                  billing.fareTariff._id &&
                                  billing.fareTariff._id.length > 20) ||
                                  trip.disableFareEdit
                              "
                            />
                          </td>
                          <td>
                            <v-text-field
                              v-model="item.unitCost"
                              type="number"
                              class="ma-0 pa-0"
                              @blur="calculateFare"
                              :disabled="
                                (billing.fareTariff &&
                                  billing.fareTariff._id &&
                                  billing.fareTariff._id.length > 20) ||
                                  trip.disableFareEdit
                              "
                            />
                          </td>
                          <td>
                            <v-text-field
                              v-model="item.amount"
                              type="number"
                              class="ma-0 pa-0"
                              disabled
                            />
                          </td>
                          <td>
                            <v-row>
                              <v-col cols="12" md="12">
                                <v-btn
                                  class="float-left"
                                  color="error"
                                  x-small
                                  fab
                                  text
                                  dark
                                  v-if="
                                    charge &&
                                      !trip.disableFareEdit &&
                                      charge.items.length > 1
                                  "
                                  @click="remove(charge.items, i, true)"
                                >
                                  <v-icon>mdi-minus-circle</v-icon>
                                </v-btn>
                                <v-btn
                                  class="float-left"
                                  v-if="
                                    charge &&
                                      charge.items.length == i + 1 &&
                                      !trip.disableFareEdit
                                  "
                                  @click="charge.items = newItem(charge.items)"
                                  text
                                  x-small
                                  fab
                                  color="blue"
                                >
                                  <v-icon>mdi-plus</v-icon>
                                </v-btn>
                              </v-col>
                            </v-row>
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </td>
                  <td style="padding-left: 0px; padding-right: 0px">
                    <v-simple-table v-if="charge" dense>
                      <thead>
                        <tr style="background-color: rgb(235 244 246)">
                          <th width="40%">{{ $i18n.t("Name") }}</th>
                          <th width="40%">{{ $i18n.t("Amount") }}</th>
                          <th>
                            <v-btn
                              v-if="
                                charge &&
                                  (!charge.discounts ||
                                    charge.discounts.length == 0) &&
                                  !trip.disableFareEdit
                              "
                              @click="
                                charge.discounts = newDiscountItem(
                                  charge.discounts
                                )
                              "
                              text
                              x-small
                              fab
                              color="blue"
                            >
                              <v-icon>mdi-plus</v-icon>
                            </v-btn>
                          </th>
                        </tr>
                      </thead>
                      <tbody v-if="charge.discounts && charge.discounts.length">
                        <tr v-for="(disc, i) in charge.discounts" :key="i">
                          <td>
                            <z-name-master-select
                              v-model="disc.name"
                              :dense="true"
                              :type="9"
                              label
                              :addNewLabel="'Add Discount Item'"
                              :hideAddNew="true"
                              :disabled="trip.disableFareEdit"
                            />
                          </td>
                          <td>
                            <v-text-field
                              v-model="disc.amount"
                              class="ma-0 pa-0"
                              type="number"
                              @blur="calculateFare"
                              :disabled="trip.disableFareEdit"
                            />
                          </td>
                          <td>
                            <v-row>
                              <v-col cols="12" md="12">
                                <v-btn
                                  class="float-left"
                                  color="error"
                                  x-small
                                  fab
                                  text
                                  dark
                                  v-if="charge && !trip.disableFareEdit"
                                  @click="remove(charge.discounts, i, true)"
                                >
                                  <v-icon>mdi-minus-circle</v-icon>
                                </v-btn>
                                <v-btn
                                  class="float-left"
                                  v-if="
                                    charge &&
                                      charge.discounts.length == i + 1 &&
                                      !trip.disableFareEdit
                                  "
                                  @click="
                                    charge.discounts = newDiscountItem(
                                      charge.discounts
                                    )
                                  "
                                  text
                                  x-small
                                  fab
                                  color="blue"
                                >
                                  <v-icon>mdi-plus</v-icon>
                                </v-btn>
                              </v-col>
                            </v-row>
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </td>
                  <td width="20%" style="padding-right: 0px">
                    <z-tax-select
                      class1="ma-0 pa-0"
                      v-model="charge.taxItem.tax_id"
                      :item="charge.taxItem"
                      :corp="trip.vendor_id"
                      @fullTax="fullTax"
                      @input="calculateFare"
                      hideLabel
                      :disabled="trip.disableFareEdit"
                    />
                  </td>
                  <td>
                    <v-row>
                      <v-col cols="12" md="12">
                        <v-btn
                          class="float-left"
                          color="error"
                          x-small
                          fab
                          text
                          dark
                          v-if="
                            fare &&
                              !trip.disableFareEdit &&
                              fare.charges.length > 1
                          "
                          @click="remove(fare.charges, i, true)"
                        >
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-btn
                          class="float-left"
                          v-if="
                            fare &&
                              fare.charges.length == i + 1 &&
                              !trip.disableFareEdit
                          "
                          @click="fare.charges = newChargeItem(fare.charges)"
                          text
                          x-small
                          fab
                          color="blue"
                        >
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
          <v-col
            cols="12"
            md="12"
            sm="12"
            v-show="fare && fare.total != null"
            class="text-right float-right"
          >
            <ul style="list-style-type: none">
              <!-- <li>
              <strong>{{ $i18n.t("Sub Total") }} :</strong>
              {{fare.subTotal }}
            </li>-->
              <li>
                <strong>{{ $i18n.t("Discount") }} :</strong>
                {{ fare.totalDiscounts }}
              </li>
              <li>
                <strong>{{ $i18n.t("Subtotal") }} :</strong>
                {{ fare.subTotal }}
              </li>
              <li
                v-show="fare.taxes"
                v-for="(tax, j) in fare.taxes"
                :key="j + 'tax'"
              >
                <span>{{ tax.name }}</span>
                {{ tax.amount }}
              </li>
              <li>
                <strong>{{ $i18n.t("Total Tax") }} :</strong>
                {{ fare.totalTaxes }}
              </li>
              <li>
                <strong
                  >{{ $i18n.t("Total with Tax") }} ({{
                    fare.currency
                  }}):</strong
                >
                {{ fare.total }}
              </li>
             <!--  <li v-if="margin && !this.forSupplier">
                <strong>{{ $i18n.t("Margin") }} ({{ fare.currency }}):</strong>
                {{ margin }}
              </li> -->
              <li v-if="fare.pending != null && fare.pending != undefined">
                <strong>{{ $i18n.t("Pending") }}:</strong>
                {{ fare.pending }}
              </li>
            </ul>
          </v-col>
        </v-row>
      </v-card-text>
    </v-expand-transition>

    <v-divider></v-divider>

    <supplier-payment
      v-if="trip.clientCargos && trip.clientCargos[0] && trip.clientCargos[0].client_id && trip.vendor_id && trip._id && forSupplier"
      :trip="trip"
      :billing="billing"
      :hideBills="true"
      @reload="reload"
    />
    <!-- <supplier-payment
      v-if="trip.corp_id && trip.vendor_id && trip._id && forSupplier"
      :trip="trip"
      :billing="billing"
      :hideBills="true"
      @reload="reload"
    /> -->
    <on-hold
      :onHold="trip.onHold"
      :fare="billing.fare"
      :trip_id="trip._id"
      :supplier_id="billing.vendor_id"
      @reload="reload"
      v-if="
        trip._id &&
          trip.billings.length > 0 &&
          billing.client_id != billing.vendor_id &&
          billing.client_id == trip.vendor_id &&
          $ha('108')
      "
    ></on-hold>
  </v-card>
</template>

<script>
import { CommonUtil } from "@/js/commonUtil";
import { doPost, doGetWithDownload } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import corpService from "@/store/common/module/CorpService";
import { Vue, Component, Watch } from "vue-property-decorator";
import SupplierPayment from "@/views/trip/SupplierPayment.vue";
import OnHold from "@/views/trip/OnHold.vue";
import _ from "lodash";
import CorpService from "@/store/common/module/CorpService";

@Component({
  name: "BillingFare",
  props: {
    value: {
      default: null,
    },
    vehicleType: {
      default: null,
    },
    trip: {
      default: null,
    },
    myCorp_id: {
      default: null,
    },
    forSupplier: {
      default: false,
    },
    appliedTaxSlab: {
      default: null,
    },
    recalculateFare: {
      default: null,
    },
    index: {
      default: null,
    },
  },
  components: {
    SupplierPayment,
    OnHold,
  },
})
export default class BillingFare extends Vue {
  billing = null;
  margin = null;
  fare = null;
  fareTariff = null;
  _forSupplier = false;
  dateComputed = null;
  taxList = [];
  expand=false;

  async onRateSelect(rate) {
    if (rate) {
      if (rate.tariffStructure) {
        if (!rate.tariffStructure.others) rate.tariffStructure.others = [];
        if (!rate.tariffStructure.discounts)
          rate.tariffStructure.discounts = [];
      }
      this.fareTariff = Object.assign(this.fareTariff, rate.tariffStructure);
      //   this.vehicleType = rate.tariffStructure.vehicleType;
      this.recalulateFare();
    }
  }

  removeBill() {
    this.$emit("removeBill", this.index);
  }

  reload(reload) {
    if (reload) {
      this.$root.$emit("event.trip.reload", reload);
    }
  }

  async printSupplierSummary() {
    try {
      common.setLoading(true);
      await doGetWithDownload(
        "/api/trip/" +
          this.trip._id +
          "/supplier/"+this.billing.vendor_id+"/print"
      );
      common.setLoading(false);
    } catch (e) {
      common.setLoading(false);
      common.setError(e);
    }
  }

  async recalulateFare() {
    common.setLoading(true);
    try {
      const fare = await doPost("/api/trip/calc/fare", this.trip);
      if (fare && fare.charges) {
        for (const i in fare.charges) {
          if (!fare.charges[i].taxItem) fare.charges[i].taxItem = {};
          if (!fare.charges[i].discountItem) fare.charges[i].discountItem = {};
        }
      }
      this.fare = Object.assign(this.fare, fare);
      common.setLoading(false);
    } catch (e) {
      common.setError(e);
      common.setLoading(false);
    }
  }

  calcMargin() {
    if (this.trip && this.trip.billings && this.trip.billings.length > 1) {
      let clientSubT = 0;
      let supSubT = 0;
      let nonMarginAmount = 0;
      const nonMarginItems = ["Bilty Charges", "TDS"];
      for (let i = 0; i < this.trip.billings.length; i++) {
        if (
          this.trip.billings[i].vendor_id &&
          this.trip.myCorp_id == this.trip.billings[i].vendor_id &&
          this.trip.billings[i].fare &&
          this.trip.billings[i].fare.subTotal
        ) {
          clientSubT = this.trip.billings[i].fare.subTotal;
        }
        if (
          this.trip.billings[i].vendor_id &&
          this.trip.myCorp_id != this.trip.billings[i].vendor_id &&
          this.trip.billings[i].fare &&
          this.trip.billings[i].fare.subTotal
        ) {
          supSubT = this.trip.billings[i].fare.subTotal;

          if (this.trip.billings[i].fare.charges) {
            for (
              let j = 0;
              j < this.trip.billings[i].fare.charges.length;
              j++
            ) {
              if (
                this.trip.billings[i].fare.charges[j] &&
                this.trip.billings[i].fare.charges[j].discounts
              ) {
                for (
                  let k = 0;
                  k < this.trip.billings[i].fare.charges[j].discounts.length;
                  k++
                ) {
                  if (
                    this.trip.billings[i].fare.charges[j].discounts[k] &&
                    this.trip.billings[i].fare.charges[j].discounts[k].name
                  ) {
                    for (let l = 0; l < nonMarginItems.length; l++) {
                      if (
                        nonMarginItems[l] ==
                          this.trip.billings[i].fare.charges[j].discounts[k]
                            .name &&
                        this.trip.billings[i].fare.charges[j].discounts[k]
                          .amount
                      ) {
                        nonMarginAmount =
                          nonMarginAmount +
                          this.trip.billings[i].fare.charges[j].discounts[k]
                            .amount;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      const expense =
        this.trip.miscExpense && this.trip.miscExpense.total
          ? this.trip.miscExpense.total
          : 0;
      this.margin =
        Math.round((clientSubT - supSubT - expense - nonMarginAmount) * 100) /
        100;
    }
  }

  async calculateFare() {
    if (!this.recalculateFare) {
      this.calcMargin();
      return;
    }
    
    await this.calculateCompleteFare();
    this.calcMargin();
  }

  async calculateCompleteFare() {
    await CommonUtil.calculateCompleteFare(
      this.fare,
      this.appliedTaxSlab
    );
    this.fare = _.cloneDeep(this.fare);
    this.billing.fare = this.fare;
    this.$emit("input", this.billing);
  }

  prepareFareData(fare) {
    if (fare && fare.charges) {
      for (const i in fare.charges) {
        if (!fare.charges[i].items) fare.charges[i].items = [];
        if (!fare.charges[i].taxItem) fare.charges[i].taxItem = {};
        // if (!fare.charges[i].discountItem) fare.charges[i].discountItem = {};
        if (!fare.charges[i].discounts) fare.charges[i].discounts = [];
      }
    }
    return fare;
  }

  async updateValues(value) {
    if (value) {
      if (value.fare == undefined) value.fare = { charges: [] };
      this.fare = this.prepareFareData(value.fare);
      this.billing = value;
      this.fareTariff = this.billing.fareTariff;
    }
  }

  @Watch("forSupplier")
  onTripUpdate(val) {
    this._forSupplier = val;
  }

  async mounted() {
    await this.updateValues(this.value);
    this.dateComputed = this.$moment(this.trip.startTime * 1000).format(
      "YYYYMMDD"
    );
    await CorpService.populateTaxes(this.myCorp_id);
    this.taxList = CorpService.taxes[this.myCorp_id];
    this.$root.$on("reloadMargin", () => {
      this.calcMargin();
    });
  }

  fullTax(taxDetail, item) {
    item.taxDetail = taxDetail;
  }

  @Watch("appliedTaxSlab")
  async onAppliedTaxSlabChange() {
    await this.calculateCompleteFare();
  }

  @Watch("value")
  async onValueChange(val) {
    await this.updateValues(val);
  }

  newChargeItem(itemList) {
    let tax_id =
      itemList &&
      itemList.length > 0 &&
      itemList[0].taxItem &&
      itemList[0].taxItem.tax_id
        ? itemList[0].taxItem.tax_id
        : null;

    if (this.forSupplier) {
      if (this.taxList != null) {
        for (let _i = 0; _i < this.taxList.length; _i++) {
          if (this.taxList[_i].name && this.taxList[_i].name.includes("ZERO")) {
            tax_id = this.taxList[_i]._id;
          }
        }
      }
    }

    if (itemList == null) itemList = [];

    const item = {
      taxItem: { tax_id: tax_id },
      // units: 1,
      // discountItem: {},
      discounts: [],
      items: [
        {
          name: null,
          desc: null,
          units: 1,
          unitCost: null,
          amount: null,
        },
      ],
    };

    if (itemList.length < 1) {
      item.items[0].name = "Freight Charge";
    }

    itemList.push(item);
    return itemList;
  }

  newDiscountItem(itemList) {
    if (itemList == null) itemList = [];
    itemList.push({ name: null, amount: null });
    return itemList;
  }

  newItem(itemList) {
    if (!itemList) itemList = [];
    itemList.push({
      name: null,
      desc: null,
      units: 1,
      unitCost: null,
      amount: null,
    });
    return itemList;
  }

  remove(list, _index, calcFare) {
    list.splice(_index, 1);
    if (calcFare) this.calculateFare();
  }
}
</script>

<style scoped>
.card-title-head {
  background-color: rgb(211, 235, 240);
  height: 40px;
  padding-top: 0px;
  color: #3b7776;
}
.supplier-title-head {
  background-color: rgb(234, 234, 234);
}
</style>
